import React, { useEffect, useState } from "react";
import { Modal } from "@pd/pd-ui-kit";
import { useTranslation } from "react-i18next";

import Preloader from "~/components/Preloader";
import FormContract, {
  contractFormId,
} from "~/pages/ListOfDocuments/Modals/Components/FormContract";
import { useAddContract, useDefaultDataContract } from "~/entity/Contract";
import { DealerContractIProps } from "~/entity/Contract/model/schema";
import { dateFormatUTC } from "~/pages/ListOfDocuments/helper";
import { TITLES } from "~/pages/ListOfDocuments/Modals/options";
import { useNotify } from "~/shared/hooks/useNotify";

interface CreateContractIProps {
  open: boolean;
  onClose: () => void;
  dealerObj: DealerContractIProps;
}

const defaultValues = {
  inn: "",
  code: "",
  name: "",
  category: "",
  contractNumber: "",
  contractDate: "",
  printFormId: "",
  avtovazAccount: null,
  avtovazBank: "",
  accountStartDate: "",
  GP: "",
  isHeadCompany: "",
  confidantId: "",
  vaz_requisitesId: "",
  startPrintDate: "",
  endPrintDate: "",
  closeDateForIS: "",
  dealerSignedDate: "",
  workStartDate: "",
};

const CreateContract = ({ open, onClose, dealerObj }: CreateContractIProps) => {
  const { data, isLoading } = useDefaultDataContract(dealerObj.id.toString());
  const [loading, setLoading] = useState(false);
  const [defaultValuesContract, setDefaultValuesContract] =
    useState(defaultValues);
  const { notifySuccess, notifyError } = useNotify();
  const { t } = useTranslation();
  const { mutate } = useAddContract();

  useEffect(() => {
    if (data?.dataMain && !isLoading) {
      Object.keys(data.dataMain).forEach((key) => {
        setDefaultValuesContract((state) => {
          return { ...state, [key]: data.dataMain[key] };
        });
      });
      setLoading(true);
    }
  }, [data, isLoading]);

  const submit = (data) => {
    const newData = {
      dealerId: dealerObj.id,
      contracttype: "main",
      contractNumber: data.contractNumber,
      contractDate: dateFormatUTC(data.contractDate),
      dealerSignedDate: data.dealerSignedDate
        ? dateFormatUTC(data.dealerSignedDate)
        : "",
      accountStartDate: dateFormatUTC(data.accountStartDate),
      closeDateForIS: data.closeDateForIS
        ? dateFormatUTC(data.closeDateForIS)
        : "",
      isSignedByDealer: data?.dealerSignedDate ? true : false,
      confidantId: Number(data.confidantId.value),
      workStartDate: data.workStartDate
        ? dateFormatUTC(data.workStartDate)
        : "",
      avtovazBank: data.avtovazBank,
      avtovazAccount: data.avtovazAccount.label,
      printFormId: Number(data.printFormId.value),
      isHeadCompany: data.isHeadCompany === "Да" ? true : false,
      vaz_requisitesId: data.vaz_requisitesId,
      startPrintDate: data.startPrintDate
        ? dateFormatUTC(data.startPrintDate)
        : "",
      endPrintDate: data.endPrintDate ? dateFormatUTC(data.endPrintDate) : "",
    };
    mutate(
      {
        ...newData,
      },
      {
        onSuccess: () => {
          notifySuccess(t("contract.create_contract_success"));
          onClose();
        },
        onError: () => {
          notifyError(t("contract.create_contract_error"));
        },
      },
    );
  };

  const formReady = !isLoading && loading;

  return (
    <Modal
      open={open}
      title={TITLES.doc.create}
      onCancel={onClose}
      centered
      destroyOnHidden
      size="large"
      cancelButton={{ children: "Закрыть" }}
      okButton={
        formReady
          ? {
              htmlType: "submit",
              form: contractFormId,
              children: "Сохранить",
            }
          : undefined
      }
    >
      {formReady ? (
        <FormContract defaultValues={defaultValuesContract} submit={submit} />
      ) : (
        <Preloader />
      )}
    </Modal>
  );
};

export default CreateContract;
